import { Anchor, Group, Stack, Text } from '@mantine/core'
import { faEnvelope, faPhone } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatPhone } from '@phoenix-web/utils/general'
import GravatarImage from './GravatarImage'

const emailAndPhoneStyles = {
  display: 'flex',
  flex: 'row',
  alignItems: 'center',
  gap: 'var(--mantine-spacing-xs)',
  textDecoration: 'none',
  color: 'var(--mantine-color-dark-gray-1)',
}

export default function ContactCard({
  circleColor,
  name,
  title,
  company,
  email,
  phone,
  nmlsId,
  fetchProfileImage = false,
}: {
  circleColor: string
  name: string
  title?: string
  company?: string
  email?: string
  phone?: string
  nmlsId?: string
  fetchProfileImage?: boolean
}) {
  // Get the first letters of the first and last name to display in the circle
  // There may only be one name, so handle for that
  const nameArray = name.split(' ')
  const firstInitial = nameArray[0][0]
  const lastInitial = nameArray.length > 1 ? nameArray[1][0] : ''

  // Combine the initials to display in the circle
  const initials = (firstInitial + lastInitial).toUpperCase()
  return (
    <Group wrap="nowrap" align="flex-start">
      {fetchProfileImage ? (
        <GravatarImage email={email} imgHeight={56} imgWidth={56} />
      ) : (
        <Group
          align="center"
          justify="center"
          style={{ borderRadius: 50, height: '3.5rem', width: '3.5rem', minWidth: '3.5rem' }}
          bg={circleColor}
        >
          <Text c="brand-blue.9" size="xl" fw={700}>
            {initials}
          </Text>
        </Group>
      )}
      <Stack pt="xs" gap="xs">
        <Stack gap="0">
          <Text fw={700}>{name}</Text>

          <Group gap={0}>
            {title && <Text>{title}</Text>}{' '}
            {title && nmlsId && (
              <Text>
                {'\u00A0'}/{'\u00A0'}
              </Text>
            )}
            {nmlsId && <Text>NMLS #{nmlsId}</Text>}
          </Group>

          {company && <Text>{company}</Text>}
        </Stack>
        <Stack gap="2px">
          {email && (
            <Anchor style={emailAndPhoneStyles} href={`mailto:${email}`}>
              <FontAwesomeIcon icon={faEnvelope} />
              {email}
            </Anchor>
          )}
          {phone && (
            <Anchor style={emailAndPhoneStyles} href={`tel:${phone}`}>
              <FontAwesomeIcon icon={faPhone} />
              {formatPhone(phone)}
            </Anchor>
          )}
        </Stack>
      </Stack>
    </Group>
  )
}
